import { MapPin, Phone, Mail, Clock, ExternalLink } from "lucide-react";
import { cafeInfo } from "@/data/menu";

export default function LocationHours() {
  return (
    <section
      id="standort"
      data-testid="location-section"
      className="section-pad bg-white"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 mb-14">
          <div className="md:col-span-7">
            <span className="eyebrow">Standort & Öffnungszeiten</span>
            <h2 className="font-display mt-4 text-5xl font-bold leading-[0.95] tracking-tight text-brand md:text-6xl">
              Komm vorbei am Chlodwigplatz.
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9 md:pt-8">
            <p className="text-lg leading-relaxed text-[#5c5752]">
              Mitten in der Südstadt – nur ein paar Minuten von der Severinstorburg.
              Wir freuen uns auf deinen Besuch.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-12 md:gap-10">
          {/* Map */}
          <div className="md:col-span-7">
            <div
              data-testid="location-map"
              className="aspect-[4/3] w-full overflow-hidden rounded-3xl border border-warm"
            >
              <iframe
                title="Scoops&Co Standort Karte"
                src={cafeInfo.osmEmbed}
                className="h-full w-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <div className="mt-4 flex flex-wrap gap-3">
              <a
                href={cafeInfo.googleMaps}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="location-google-maps-link"
                className="btn-ghost"
              >
                Route in Google Maps
                <ExternalLink size={16} />
              </a>
              <a
                href={cafeInfo.osmLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="location-osm-link"
                className="link-underline text-sm text-brand self-center"
              >
                Größere Karte ansehen
              </a>
            </div>
          </div>

          {/* Info */}
          <div className="md:col-span-5">
            <div className="rounded-3xl border border-warm bg-cream p-8 md:p-10">
              <div className="flex items-start gap-4">
                <div className="rounded-full bg-white p-3 border border-warm">
                  <MapPin size={18} strokeWidth={1.75} />
                </div>
                <div>
                  <p className="eyebrow">Adresse</p>
                  <p
                    data-testid="location-address"
                    className="font-display mt-2 text-2xl font-semibold text-brand"
                  >
                    {cafeInfo.address.street}
                  </p>
                  <p className="text-base text-[#5c5752]">
                    {cafeInfo.address.zip} {cafeInfo.address.city}
                  </p>
                </div>
              </div>

              <div className="mt-8 flex items-start gap-4">
                <div className="rounded-full bg-white p-3 border border-warm">
                  <Phone size={18} strokeWidth={1.75} />
                </div>
                <div>
                  <p className="eyebrow">Telefon</p>
                  <a
                    href={cafeInfo.phoneHref}
                    data-testid="location-phone"
                    className="font-display mt-2 block text-2xl font-semibold text-brand link-underline"
                  >
                    {cafeInfo.phone}
                  </a>
                </div>
              </div>

              <div className="mt-8 flex items-start gap-4">
                <div className="rounded-full bg-white p-3 border border-warm">
                  <Mail size={18} strokeWidth={1.75} />
                </div>
                <div>
                  <p className="eyebrow">E-Mail</p>
                  <a
                    href={`mailto:${cafeInfo.email}`}
                    data-testid="location-email"
                    className="font-display mt-2 block text-xl font-semibold text-brand link-underline break-all"
                  >
                    {cafeInfo.email}
                  </a>
                </div>
              </div>

              <div className="mt-8 flex items-start gap-4">
                <div className="rounded-full bg-white p-3 border border-warm">
                  <Clock size={18} strokeWidth={1.75} />
                </div>
                <div className="flex-1">
                  <p className="eyebrow">Öffnungszeiten</p>
                  <ul
                    data-testid="location-hours"
                    className="mt-3 divide-y divide-warm border-t border-warm"
                  >
                    {cafeInfo.hours.map((h) => (
                      <li
                        key={h.day}
                        className="flex justify-between gap-4 py-2.5 text-sm md:text-base"
                      >
                        <span className="text-brand font-medium">{h.day}</span>
                        <span className="text-[#5c5752] tabular-nums">
                          {h.time}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
